<template lang="pug">
  div.location-tariff-update.without-tabs
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      :hideDeleteButton="false"
      saveBtnLabel="Произвести расчет"
      savingBtnLabel="Расчет..."
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
                name="geo_object"
                label="Муниципальное образование"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

              e-form-group(
                name="population"
                label="Население"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

              e-form-group(
                name="area"
                label="Площадь"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

            div.col
              e-form-group(
                name="containers_count"
                label="Общее количество контейнеров"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

              e-form-group(
                name="container_volume"
                label="Средний объём контейнерной площадки"
                :model="fields"
                tabView="tab1"
                :required="true"
                validationRule="double"
              )

              e-form-group(
                name="transport_distance"
                label="Среднее расстояние транспортировки ТБО"
                :model="fields"
                tabView="tab1"
                :required="true"
                validationRule="double"
              )

              e-form-group(
                name="msn_distance"
                label="Среднее расстояние между местами сбора"
                :model="fields"
                tabView="tab1"
                :required="true"
                validationRule="double"
              )

            div.col
              e-form-group(
                name="formed"
                label="Количество образуемых отходов куб.м./год"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

              e-form-group(
                name="tariff_burial"
                label="Тариф на захоронение"
                :model="fields"
                tabView="tab1"
                :required="true"
                validationRule="double"
              )

              e-form-group(
                name="tariff_processing"
                label="Тариф на обработку"
                :model="fields"
                tabView="tab1"
                :required="true"
                validationRule="double"
              )

          div.body
            div.col
              e-form-subtitle(text="Итоги расчета")
              e-form-group(
                name="L_tr"
                label="L тр"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="L_ost"
                label="L ост метры"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="M"
                label="М ост метры"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="N_sred"
                label="N сред"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="O"
                label="O"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="L_sb"
                label="L сб км"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

            div.col
              e-form-subtitle(text="").is-hidden
              e-form-group(
                name="N_e"
                label="Не"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="S_zp"
                label="C зп"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="S_otch"
                label="Сотч"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="S_va"
                label="Сva"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="Q"
                label="Q"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )

            div.col
              e-form-subtitle(text="").is-hidden
              e-form-group(
                name="S_t"
                label="С т"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="S_m"
                label="C м"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="S_r"
                label="C р"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="S_oer"
                label="С оэр"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="S_pr"
                label="С пр"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )
              e-form-group(
                name="transport_tariff"
                label="Тариф на транспортировку 1 куб м тко"
                :model="fields"
                tabView="tab1"
                :disabled="true"
              )


</template>

<script>
  import {calculation} from "../../api/api-endpoints";
  import {locationTariffMixin} from "./mixins/location-tariff-mixin"

  export default {
    mixins: [locationTariffMixin],
    methods: {
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return calculation.locationTariff(route.params.id)
      },
      getUpdateOrCreateUrl() {
        return calculation.locationTariffUpdate(this.$route.params.id)
      }
    }
  }
</script>
